import { render, staticRenderFns } from "./GeneradorTonosDialog.vue?vue&type=template&id=4b7d6e11&scoped=true&"
import script from "./GeneradorTonosDialog.vue?vue&type=script&lang=js&"
export * from "./GeneradorTonosDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7d6e11",
  null
  
)

export default component.exports